import { TRootState, TBillsState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { billsAdapter } from './adapter'

const selectState = (state: TRootState): TBillsState => state.bills

const adapterSelectors = billsAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus
}